import { Link } from '@mui/material';
import BlockData from '../../../../models/BlockData';
import CroppedImage from '../../../CroppedImage';
import ImageSettingsModal from '../../../Modals/ImageSettingsModal/ImageSettingsModal';
import BlockImageListItemData from '../BlockImageListItemData';
import BlockComponentImage from '../../../../models/BlockComponentValues/BlockComponentImage';

interface BlockImageListItemProps {
  item: BlockImageListItemData;
  isTemplate: boolean;
  isEditing: boolean;
  blockData: BlockData[];
  onUpdate: (item: BlockComponentImage) => void;
  targetModalId: string;
}

const BlockImageListItem = ({
  item,
  isTemplate,
  isEditing,
  blockData,
  onUpdate,
  targetModalId,
}: BlockImageListItemProps) => {
  const { image } = item;
  return (
    <ImageSettingsModal isEditing={isEditing} image={item.image} disabled={isTemplate || !isEditing} blockData={blockData} onConfirm={onUpdate}>
      {!isEditing ? (
        <Link
          style={{ cursor: item?.image?.link?.linkData?.url ? 'pointer' : 'default' }}
          target={item?.image?.link?.linkData?.openType}
          href={item?.image?.link?.linkData?.url || undefined}
          sx={{
            width: '100%',
            height: 'auto',
          }}
          rel="noreferrer"
        >
          <CroppedImage
            image={image}
            isEditing={isEditing}
            settings={image.settings}
            targetModalId={targetModalId}
          />
        </Link>
      ) : (
        <>
          <CroppedImage
            image={image}
            isEditing={isEditing}
            settings={image.settings}
            targetModalId={targetModalId}
          />
        </>
      )}
    </ImageSettingsModal>
  );
};

export default BlockImageListItem;
